import ReactDOM from 'react-dom/client';
import { StrictMode, Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorPage from './pages/error';

import App from './app';
import { CONFIG } from './config-global';

// ----------------------------------------------------------------------

async function initApp() {
  const root = ReactDOM.createRoot(document.getElementById('root'));

  root.render(
    <ErrorBoundary fallbackRender={ErrorPage}>
      <StrictMode>
        <HelmetProvider>
          <BrowserRouter basename={CONFIG.site.basePath}>
            <Suspense>
              <App />
            </Suspense>
          </BrowserRouter>
        </HelmetProvider>
      </StrictMode>
    </ErrorBoundary>
  );
}

initApp();
